const orderCz = {
    "total": "Celkový",
    "order_successfully_placed": "Objednávka zadána",
    "empty_cart": "Váš košík je momentálně prázdný",
    "place_order": "Odeslat objednávku",
    "i_order": "Odeslat objednávku",
    "order_confirmation": "Potvrzení objednávky",
    "order_confirmation_msg_raw": "Odesláním objednávky souhlasíte s našimi podmínkami použití a zásadami ochrany osobních údajů, které naleznete v <a href=\":link\" class=\"generated-link\" target=\"_blank\">odkazu níže</a>.",
    "status_PLACED": "Umístěno",
    "status_ACCEPTED": "Přijato",
    "status_SERVED": "Obsluhováno",
    "status_PAID": "Placené",
    "empty_pending_orders": "Momentálně nemáte žádné čekající objednávky",
    "overview": "Přehled objednávky",
    "note": "Poznámka",
    "items": "Položky",
    "review_order": "Přehled"
};

export default orderCz;
